module.exports = __webpack_public_path__ + "Roboto-Regular.ac3f799d5bbaf5196fab.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/@c4/assets/src/assets/fonts/roboto/Roboto-Regular.ttf
// module id = 388
// module chunks = 2